import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-insufficient-permission',
  templateUrl: './app-insufficient-permission.component.html',
  styleUrls: ['./app-insufficient-permission.component.scss'],
  standalone: false,
})
export class AppInsufficientPermissionComponent implements OnInit {
  partnerId: string;
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.partnerId = (this.route.snapshot.params as AppInsufficientPermissionComponent).partnerId;
  }
}
